import { Stack } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import Text from 'components/shared/Text';
import { useDevices } from 'utils/devices';

import s from './Stub.module.scss';

export type StubProps = {
  className?: string;
  fullHeight?: boolean;
  icon?: React.ReactNode;
  title?: string;
  action?: React.ReactNode;
};

const Stub: React.FC<StubProps> = ({ className, fullHeight, icon, title, action }) => {
  const { isPhone } = useDevices();

  return (
    <div className={cn(s.root, fullHeight && s['root_full-height'], className)}>
      <Stack gap={isPhone ? 'sm' : 'xl'} align="center">
        {icon}
        {title && <Text size="md">{title}</Text>}
        {action}
      </Stack>
    </div>
  );
};

export default Stub;
